import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.regexp.replace.js";
import "core-js/modules/es6.function.name.js";
import "core-js/modules/es6.array.find.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import TeDialog from 'src/components/Dialogs/TEDialog';
import User from 'src/store/models/User';
import { dialog } from 'src/boot/mixins.js';
import { filter, forEach } from 'lodash';
export default {
  mixins: [dialog],
  components: {
    TeDialog: TeDialog
  },
  props: ['project', 'addedUsers'],
  watch: {
    allSelected: 'selectAll'
  },
  data: function data() {
    return {
      loading: false,
      allSelected: false,
      textFilter: '',
      users: []
    };
  },
  computed: {
    filteredUsers: function filteredUsers() {
      var _this = this;

      if (!this.textFilter) return this.users;
      return this.users.filter(function (user) {
        return user.name.toLowerCase().replace(/ /g, '').indexOf(_this.textFilter.toLowerCase().replace(/ /g, '')) >= 0 || user.email.toLowerCase().replace(/ /g, '').indexOf(_this.textFilter.toLowerCase().replace(/ /g, '')) >= 0;
      });
    }
  },
  methods: {
    addUsers: function addUsers() {
      var addedUsers = [];
      addedUsers = filter(this.users, function (user) {
        return user.selected === 1;
      });
      this.addedUsers(addedUsers);
      this.hide();
    },
    loadUsers: function loadUsers() {
      var _this2 = this;

      if (!this.loading && this.users.length === 0) {
        var project = this.project;
        this.loading = true;
        User.api().get('/users', {
          params: {
            abridged: 1,
            active: 1,
            group_id: this.me.is_admin ? null : this.me.is_gm ? this.me.group_id : null,
            account_id: this.me.account_id
          }
        }).then(function (response) {
          _this2.loading = false;
          _this2.users = filter(response.response.data.data, function (user) {
            var userNotLinked = true;

            if (project.users.find(function (u) {
              return parseInt(u.user_id) === parseInt(user.user_id);
            })) {
              userNotLinked = false;
            } else {
              // Prepare new user
              user.pivot = {
                is_pm: false,
                budget_minutes: 0,
                budget: {
                  budget_minutes: 0,
                  budget_amount: 0
                },
                hourly_rate: 0,
                total_minutes: 0
              };
              user.budget_hours = 0;
              user.new = 1;
              user.selected = 0;
            }

            return userNotLinked;
          });
        }).catch(function () {});
      }
    },
    selectAll: function selectAll() {
      if (this.allSelected) {
        forEach(this.filteredUsers, function (user) {
          user.selected = 1;
        });
      } else {
        forEach(this.filteredUsers, function (user) {
          user.selected = 0;
        });
      }
    }
  },
  mounted: function mounted() {
    this.loadUsers();
  }
};